import { render, staticRenderFns } from "./CatalogoEletronico.vue?vue&type=template&id=3cd8cffd&scoped=true"
import script from "./CatalogoEletronico.vue?vue&type=script&lang=js"
export * from "./CatalogoEletronico.vue?vue&type=script&lang=js"
import style0 from "./CatalogoEletronico.vue?vue&type=style&index=0&id=3cd8cffd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd8cffd",
  null
  
)

export default component.exports